import { IFormField } from "../web-form.objects"
import _ from "lodash";
import { JsonItem } from "../../../entities/pick-list/pick-list.entities";

export class TextInputOptions {
    inputType: TextInputType; // should add validation for email
    wordCount: number = -99; // if should validate based on words
    charCount: number = -99; // if should validate based on characters
    isReadOnly: boolean = false; // if this field should be readonly
    textAreaSize: number = 0; // number of rows for textarea (0 = normal input)
    constructor(inputType: TextInputType = TextInputType.Any, wordCount: number = -99, charCount: number = -99, isReadOnly: boolean = false, textAreaSize: number = 0) {
        this.inputType = inputType;
        this.wordCount = wordCount;
        this.charCount = charCount;
        this.isReadOnly = isReadOnly;
        this.textAreaSize = textAreaSize;
    }
}

export class TextInputField implements IFormField {
    fieldId: string; 
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    initialVal: any;
    options: TextInputOptions;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: TextInputOptions = new TextInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        
        this.options = options;

        this.defaultVal = "";
        this.initialVal = "";
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let input = `<input type="text" class="form-control col-12" id="${this.fieldId}">`;
        if (this.options.textAreaSize > 0) {
            input = `<textarea class="form-control col-12" rows="${this.options.textAreaSize}" id="${this.fieldId}"></textarea>`
        }

        let wordCount = "";
        if (this.options.wordCount > 0) {
            wordCount = `
                <div class="word-count-display">
                    ${this.options.wordCount} word max (<span class="word-count-num">0</span>/${this.options.wordCount})
                </div>`
        }
        let charCount = "";
        if (this.options.charCount > 0) {
            charCount = `
                <div class="word-count-display">
                    ${this.options.charCount} character max (<span class="word-count-num">0</span>/${this.options.charCount})
                </div>
            `
        }

        let html = `
            <label for="" class="${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            ${input}
            ${wordCount}
            ${charCount}
        `;

        return html;
    }

    initialize() {
        if (this.options.wordCount > 0) {
            this.initializeWordCount();
        }
        else if (this.options.charCount > 0) {
            this.initializeCharCount();
        }

        $(`#${this.fieldId}`).on("change keyup", () => {
            $(`#${this.fieldId}`).trigger("form-field-change");
        });
    }

    setOptions(pickLists: JsonItem[]) {
        return;
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;
        // Check if all have valid
        let isValid = items.every(item => _.get(item, this.propertyName));

        if (isValid) {
            // Check if all are the same
            if (items.every((item, i, arr) => _.get(item, this.propertyName) == _.get(arr[0], this.propertyName)) && items.length > 0) {
                this.initialVal = _.get(items[0], this.propertyName);
            }
        }

        this.setInput(this.initialVal);
    }

    updateItem(item: any): any {
        let updatedItem = _.cloneDeep(item);
        if (!this.options.isReadOnly) {
            _.set(updatedItem, this.propertyName, this.getValue());
        }
        return updatedItem;
    }

    private initializeWordCount() {
        let wordCountDisplay = $(`#${this.fieldId}`).siblings(".word-count-display").find(".word-count-num");
        $(`#${this.fieldId}`).on("keyup change", () => {
            let wordCount = this.getWordCount();
            wordCountDisplay.text(wordCount.toString());
            if (wordCount > this.options.wordCount) {
                this.displayValid(false);
            }
            else { this.resetValidDisplay(); }
        });
    }

    private initializeCharCount() {
        let charCountDisplay = $(`#${this.fieldId}`).siblings(".word-count-display").find(".word-count-num");
        $(`#${this.fieldId}`).on("keyup change", () => {
            let charCount = this.getCharCount();
            charCountDisplay.text(charCount.toString());
            if (charCount > this.options.charCount) {
                this.displayValid(false);
            }
            else { this.resetValidDisplay(); }
        });
    }

    private getWordCount(): number {
        let val = this.getInput();
        if (!val) {
            return 0; // if empty or just spaces
        }
        let wordCount = val.split(" ").length;
        return wordCount;
    }

    private getCharCount(): number {
        let val = this.getInput();
        if (!val) {
            return 0; // if empty or just spaces
        }
        let charCount = val.length;
        return charCount;
    }

    private getInput(): string {
        let input = (<string>$(`#${this.fieldId}`).val()).trim();
        return input;
    }

    private setInput(data: any): void {
        $(`#${this.fieldId}`).val(data);
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getInput();

        // word count
        if (this.options.wordCount > 0) {
            let wordCount = this.getWordCount();
            if (wordCount > this.options.wordCount) {
                return false;
            }
        }
        else if (this.options.charCount > 0) {
            let charCount = this.getCharCount();
            if (charCount > this.options.charCount) {
                return false;
            }
        }

        // email
        if (this.options.inputType == TextInputType.Email) {
            // only test if its not empty
            if (val) {
                let regex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                let isEmailValid = regex.test(val);
                if (!isEmailValid) {
                    return false;
                }
            }
        }

        // link
        if (this.options.inputType == TextInputType.Link) {
            if (val) {
                var httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
                let isLinkValid = httpRegex.test(val);
                if (!isLinkValid) {
                    return false;
                }
            }
        }

        if (this.isRequired) {
            // empty or spaces
            if (!val) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getInput();
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = <string>_.get(item1, this.propertyName);
        let x2 = <string>_.get(item2, this.propertyName);
        return x1 == x2;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";

        let newVal = _.get(newItem, this.propertyName);
        if (newVal) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${newVal}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        if (prevItem != undefined) {
            let prevVal = _.get(prevItem, this.propertyName);
            if (prevVal) {
                let prevDisplay = `
                        <div class="delete-change-block change-block">
                            <div class="col-auto">
                                <i class="fa-solid fa-trash-can delete-change-icon"></i>
                            </div>
                            <div class="col">
                                ${prevVal}
                            </div>
                        </div>
                    `;
                changeContent += prevDisplay;
            }
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}

export enum TextInputType {
    Any, 
    Email,
    Link
}

